import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'tax-info-legal',
  templateUrl: './info-legal.component.html',
  styleUrls: ['./info-legal.component.sass'],
})

export class InfoLegalComponent implements OnInit {
  // @ts-ignore
  @Input() organization;
  // @ts-ignore
  isSameAddress: boolean;
  constructor() {}

  ngOnInit(): void {
    this.isSameAddress = this.organization.actualAddress === this.organization.legalAddress;
  }
}
